// =====================================================================
// COPIAR CON RESPALDO · Peaje U-02 · 6 de octubre de 2026
// =====================================================================
// `navigator.clipboard` no existe en todos los aparatos: falta fuera de
// HTTPS, en navegadores viejos y en algunas vistas web dentro de otras
// aplicaciones, y donde existe puede rechazar la escritura. Antes, el
// asistente del segundo factor caía directo a un error. Ahora prueba tres
// caminos, en este orden:
//
//   1 · `navigator.clipboard.writeText` (el normal).
//   2 · un <textarea> fuera de pantalla + `document.execCommand('copy')`.
//   3 · ninguno: devuelve `false` y la pantalla selecciona el bloque visible
//       para que la persona lo copie a mano.
//
// Las dependencias se pueden pasar (`nav`, `doc`) para probar cada rama
// sin navegador.

/** Rótulo neutro de la tercera rama. */
export const TEXTO_SIN_PORTAPAPELES = 'Selecciona y copia a mano: el aparato no permite copiar desde aquí.';

/**
 * Copia `texto`. Devuelve 'portapapeles', 'respaldo' o `false`.
 * Nunca lanza.
 */
export async function copiarTexto(texto, { nav = globalThis.navigator, doc = globalThis.document } = {}) {
  const valor = String(texto ?? '');
  try {
    if (nav?.clipboard?.writeText) {
      await nav.clipboard.writeText(valor);
      return 'portapapeles';
    }
  } catch { /* se cae al respaldo */ }
  try {
    if (!doc?.createElement || typeof doc.execCommand !== 'function') return false;
    const area = doc.createElement('textarea');
    area.value = valor;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '0';
    area.style.left = '-9999px';
    area.style.opacity = '0';
    doc.body.appendChild(area);
    area.select();
    let ok = false;
    try { ok = doc.execCommand('copy') === true; } finally { area.remove(); }
    return ok ? 'respaldo' : false;
  } catch {
    return false;
  }
}

/** Selecciona el contenido de un elemento visible (tercera rama). */
export function seleccionarContenido(elemento, { win = globalThis.window, doc = globalThis.document } = {}) {
  try {
    if (!elemento || !win?.getSelection || !doc?.createRange) return false;
    const rango = doc.createRange();
    rango.selectNodeContents(elemento);
    const sel = win.getSelection();
    sel.removeAllRanges();
    sel.addRange(rango);
    return true;
  } catch {
    return false;
  }
}

/** Agrupa una clave de 4 en 4 SOLO para leerla; lo que se copia va sin espacios. */
export function agruparDeCuatro(clave) {
  return String(clave || '').replace(/\s+/g, '').replace(/(.{4})(?=.)/g, '$1 ');
}

/** La cuenta tal como la verá la aplicación de códigos: la etiqueta del enlace otpauth. */
export function cuentaDelEnlace(enlace) {
  const m = /^otpauth:\/\/totp\/([^?]+)/i.exec(String(enlace || ''));
  if (!m) return null;
  try {
    const etiqueta = decodeURIComponent(m[1]);
    const i = etiqueta.indexOf(':');
    return (i >= 0 ? etiqueta.slice(i + 1) : etiqueta).trim() || null;
  } catch {
    return null;
  }
}
